<template>
	<Icon v-bind="$props">
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fal"
			data-icon="pencil"
			class="svg-inline--fa fa-message"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 640 640"
		>
			<path
				class="light"
				fill="currentColor"
				d="M243.2 597.6C243.2 597.6 243.2 597.6 243.2 597.6L236.8 602.4C232 606 226.1 608 220 608C204.5 608 192 595.5 192 580L192 512L160 512C107 512 64 469 64 416L64 192C64 139 107 96 160 96L480 96C533 96 576 139 576 192L576 416C576 469 533 512 480 512L360 512C358.3 512 356.6 512.6 355.2 513.6L243.2 597.6zM224 532L224 572L336 488C342.9 482.8 351.3 480 360 480L480 480C515.3 480 544 451.3 544 416L544 192C544 156.7 515.3 128 480 128L160 128C124.7 128 96 156.7 96 192L96 416C96 451.3 124.7 480 160 480L200 480C213.3 480 224 490.7 224 504L224 532z"
			></path>
			<path
				class="regular"
				fill="currentColor"
				d="M267.7 576.9C267.7 576.9 267.7 576.9 267.7 576.9L229.9 603.6C222.6 608.8 213 609.4 205 605.3C197 601.2 192 593 192 584L192 512L160 512C107 512 64 469 64 416L64 192C64 139 107 96 160 96L480 96C533 96 576 139 576 192L576 416C576 469 533 512 480 512L359.6 512L267.7 576.9zM332 472.8C340.1 467.1 349.8 464 359.7 464L480 464C506.5 464 528 442.5 528 416L528 192C528 165.5 506.5 144 480 144L160 144C133.5 144 112 165.5 112 192L112 416C112 442.5 133.5 464 160 464L216 464C226.4 464 235.3 470.6 238.6 479.9C239.5 482.4 240 485.1 240 488L240 537.7C272.7 514.6 303.3 493 331.9 472.8z"
			></path>
			<path
				class="solid"
				fill="currentColor"
				d="M64 416L64 192C64 139 107 96 160 96L480 96C533 96 576 139 576 192L576 416C576 469 533 512 480 512L360 512C354.8 512 349.8 513.7 345.6 516.8L230.4 603.2C226.2 606.3 221.2 608 216 608C202.7 608 192 597.3 192 584L192 512L160 512C107 512 64 469 64 416z"
			></path>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'MessageIcon',
	components: { Icon },
	props,
}
</script>
